import { ProposalPackageLevel } from './proposalpackagelevel';

/**
 * TMS-14254 Flag to PE when new submitted proposal for an existing part does not match the last approved proposal
 * Get a proposal for review. It returns warning info to show package levels, supplier code/name, the part number from approved proposals
 * with the same base7 part number, different dimensions, QPC (primary), 
 * TotalContainerQuantity, TotalPartQuantity, and TotalWeight (second, tertiary) at each package level.
 */
export class ProposalWarning {
    ProposalId: number;
    SupplierName: string;
    SupplierCode: string;
    PartNumber: string;
    WorkflowStatusId: number;
    ProposalPackageLevels: ProposalPackageLevel[];

    constructor() {
        this.ProposalPackageLevels = [];
    }
}